import React from "react";
import Layout from "./../components/Layout/Layout";
import { Box, Typography } from "@mui/material";

const About = () => {
  return (
    <Layout>
      <Box
        sx={{
          my: 15,
          textAlign: "center",
          p: 2,
          "& h4": {
            fontWeight: "bold",
            my: 2,
            fontSize: "2rem",
          },
          "& p": {
            textAlign: "justify",
          },
          "@media (max-width:600px)": {
            mt: 0,
            "& h4 ": {
              fontSize: "1.5rem",
            },
          },
        }}
      >
        <Typography variant="h4">Welcome To My Resturant</Typography>
        <p>
          My name is Parvej Ali, student at IIIT Kota pursuing B.tech with Electronics and Communication Engineering. I am currently in 7th semester. <br />

          {/* <button onClick = {() => {
                    window.location.href = "https://parvej0ali.github.io/MyResume.github.io/"
                  }}>About Me</button> */}
        </p>
        <br />
        <p>
        <button onClick = {() => {
                    window.location.href = "https://parvej0ali.github.io/MyResume.github.io/"
                  }}>About Me</button>
        </p>
      </Box>
    </Layout>
  );
};

export default About;
